import Vue from 'vue'
import Vuex from 'vuex'
import getters from '@/store/getters'

import home from './modules/Home'

import mutations from './mutations'
import state from './state'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    ...state
  },
  modules: {
    home
  },
  mutations: {
    ...mutations
  },
  actions: {

  },
  getters
})
